import getOption from './getOption';
import { SUPPORT_LABELS, SUPPORT_TAGS } from '../constants';

var supportSort = function supportSort(a, b) {
  return SUPPORT_TAGS.indexOf(a.toLowerCase()) - SUPPORT_TAGS.indexOf(b.toLowerCase());
};

var support = function support(_ref) {
  var label = _ref.label,
      values = _ref.values,
      urlParams = _ref.urlParams;
  var param = 'supportFilter';
  var options = values.sort(supportSort).map(function (support) {
    return {
      ariaLabel: "Click to filter by ".concat(SUPPORT_LABELS[support.toLowerCase()]),
      label: SUPPORT_LABELS[support.toLowerCase()],
      value: support
    };
  });
  return {
    expand: false,
    filter: function filter(product, value) {
      return product.properties.supportDisplay === value;
    },
    label: label,
    param: param,
    options: options,
    selected: getOption(options, urlParams.get(param))
  };
};

export default support;